export const GetApplicationUserEdit = "/ApplicationUser/GetUser";

export const ApplicationUserPaymentFeeWithUSDT =
  "/ApplicationUser/ApplicationUserPaymentFeeWithUSDT";
